import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CopyNew",
  "use": "svg-icon-CopyNew-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-CopyNew\"><path fill-rule=\"evenodd\" d=\"M11 0H0v11h11V0zM9 2H2v7h7V2z\" /><path fill-rule=\"evenodd\" d=\"M5 12v4h11V5h-4v2h2v7H7v-2H5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol